import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import "firebase/messaging";
import httpclient from "../httpclient";
import SwalToast from "../helpers/SwalToast";
import Cookie from "js-cookie";
import IsEmpty from "../helpers/IsEmpty";

const firebaseConfig = {
  apiKey: "AIzaSyC3G5Q84XejQTdjqVzQs-3aYJagSsusu8Q",
  authDomain: "degadai-3229f.firebaseapp.com",
  projectId: "degadai-3229f",
  storageBucket: "degadai-3229f.appspot.com",
  messagingSenderId: "481864323765",
  appId: "1:481864323765:web:0ff278194d43279f6364fc",
  measurementId: "G-GZK9N4D19E",
};
initializeApp(firebaseConfig);

const messaging = getMessaging();
const { REACT_APP_VAPID_KEY } = process.env;
const publicKey = REACT_APP_VAPID_KEY;

export const onGetToken = async (setTokenFound) => {
  let token = "";
  await getToken(messaging, { vapidKey: publicKey })
    .then((currentToken) => {
      if (currentToken) {
        console.log("[Token]", currentToken);
        setTokenFound(true);
        token = currentToken;

        Cookie.set("firebase_granted", true);
        Cookie.set("firebase_token", currentToken);
      } else {
        setTokenFound(false);
        // ...
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // ...
    });
  return token;
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
    // messaging.onMessage((payload) => {
    //   resolve(payload);
    // });
  });
